import React from 'react';
import styled from 'styled-components'

const SpaceBetween = styled.div`
    display: ${({ show = true }) => show ? 'block' : 'none'};
    width: ${({ width = 30 }) => `${width}px`};
`;

export default SpaceBetween;
